export default __webpack_public_path__ + "static/media/more-about-jumps.7c055911.md";